import { Injectable, NgZone } from "@angular/core"
import {ConnectionType, Network} from '@capacitor/network';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceNetworkService {
  private networkStatus = new BehaviorSubject<'connected' | 'disconnected'>('connected');
  type: ConnectionType = 'unknown';

  constructor(private readonly ngZone: NgZone) {
  }

  getNetworkStatus(): Observable<string> {
    return this.networkStatus.asObservable();
  }

  async initializeNetworkEvents() {
    const status = await Network.getStatus();
    this.networkStatus.next(status.connected ? 'connected' : 'disconnected');

    await Network.addListener('networkStatusChange', (status) => {
      this.ngZone.run(() => {
        this.networkStatus.next(status.connected ? 'connected' : 'disconnected');
        this.type  = status.connectionType;
      })
    });
  }

}
